import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import { withRouter } from "react-router-dom";

import { Layout, Spin, Modal } from "antd";

import Slimpay from "./Slimpay";
import CreditCardForm from "./CreditCardForm";

import { ModalValidationError } from "../../../commonComponents";

import "./Step_4.css";

@withRouter
@inject("translationsStore", "step4RegistrationStore", "profileStore", "registrationStore", "usersStore")
@observer
export default class Step_4 extends Component {
  constructor(props) {
    super(props);

    this.state = {
      inProgress: false,
      message: ""
    };
  }

  componentDidMount() {
    if (!this.props.step4RegistrationStore.session) {
      this.props.history.push("/registrations");
    }
    if (!this.props.registrationStore.paymentType) {
      this.setState({
        inProgress: true,
        message: "No payment type defined. You will be redirected to the payment type selection page"
      });
      setTimeout(() => {
        this.props.history.push("/registration/step_3");
      }, 2000);
    } else {
      this.props.registrationStore.setPosition(4);
      if (this.props.registrationStore.isPaymentExternal) {
        this.props.step4RegistrationStore.updateSubscription(this.props.step4RegistrationStore.createNextStatus()).then(() => {
          this.props.history.push("/registration/step_5");
        });
      }
    }
  }

  componentWillUnmount() {
    this.setState({ inProgress: false, message: "" });
  }

  slimpayCallback(data) {
    this.props.step4RegistrationStore
      .updateSubscription(this.props.step4RegistrationStore.createNextStatus())
      .then(() => this.props.history.push("/registration/step_5"))
      .catch(error => {
        let errorObj = { title: "Unknown error" };
        if (error) {Object.assign(errorObj, { title: error.name }, { content: error.details[0].message });}
        Modal.error(errorObj);
      });
  }

  afterCreditCardSubmission() {
    this.setState({ inProgress: true });
    this.props.step4RegistrationStore
      .updateSubscription(this.props.step4RegistrationStore.createNextStatus())
      .then(() => this.props.history.push("/registration/step_5"))
      .catch(error => {
        ModalValidationError(error);
      })
      .finally(() => {
        this.setState({ inProgress: false });
      });
  }

  render() {
    const {
      step4RegistrationStore: { paymentType, slimpayHtml, user: { zuoraId: profileId } = {} }
    } = this.props;
    return (
      <Layout className="Step_4">
        {!this.state.inProgress &&
          paymentType === "SEPA" && <Slimpay html={slimpayHtml} profileId={profileId} callback={this.slimpayCallback.bind(this)} />}
        {this.state.inProgress && <Spin tip={`${this.state.message}||...`} />}
        {!this.state.inProgress &&
          paymentType === "Credit Card" && (
            <CreditCardForm
              ref={cc => {
                this.cc = cc;
              }}
              profile={this.props.profileStore.profile}
              afterCreditCardSubmission={this.afterCreditCardSubmission.bind(this)}
            />
          )}
      </Layout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/RegistrationSteps/Step_4/Step_4.js